import {IntermediatePart} from "../../intermediatePart";

export default class Cabinet extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.dbName = 'Center Island Cabinet';
    this.partId = 'center_island_cabinet';
    this.partName = 'Cabinet';
    this.translateId = "visualizer.kitchen.center_island.center_island_cabinet";
    this.canBeDisabled = true;
    this.allWallsCanBeApplied = true;
  }

  disabledClick() {
    const centerIslandParent = this.getParent();
    centerIslandParent.relatedItems.forEach(featureGroup => {
      featureGroup.disabled = this.disabled;
    })
    const ponyWall = centerIslandParent.layout && centerIslandParent.layout.parts && centerIslandParent.layout.parts.Walls
      ? centerIslandParent.layout.parts.Walls.ponyWall
      : null;
    if (ponyWall) {
      ponyWall.disabled = this.disabled;
    }
  }
}
